"use strict";

module.exports = function MissingArgumentError(message) {
    Error.captureStackTrace(this, this.constructor);
    this.name = this.constructor.name;
    this.message = message;
};
require("util").inherits(module.exports, Error);
//# sourceMappingURL=missingArgument.js.map
//# sourceMappingURL=missingArgument.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/errors/missingArgument.js
// module id = 58
// module chunks = 0